import { RDEqipRequiredForms } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { RDEqipRequiredFormsTaskEditor } from './RDEqipRequiredFormsTaskEditor'

export const RDEqipRequiredFormsResourceDetailFeature: ResourceDetailFeature<RDEqipRequiredForms> =
  {
    traitId: 'eqipRequiredForms',
    TaskEditor: RDEqipRequiredFormsTaskEditor,
  }
